<template>
  <b-overlay :show="isLoading">
    <b-row>
      <b-col cols="12">
        <b-card> </b-card>
      </b-col>
    </b-row>
  </b-overlay>
</template>

<script>
export default {
  data() {
    return {
      isLoading: false,
      examDetails: null,
    };
  },
  methods: {
    getASingleExam() {
      try {
        this.isLoading = true;
        let _this = this;
        let getExamWithAnswers = new GetExamWithAnswers(_this);
        getExamWithAnswers.setRequestParam({});
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  components: {
    BCard,
    BRow,
    BCol,
    BOverlay,
  },
};
import { GetExamWithAnswers } from "@/libs/Api/Exam";
import { BCard, BRow, BCol, BOverlay } from "bootstrap-vue";
</script>
